module.exports = __webpack_public_path__ + "static/media/158.a97c2266.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/158.jpg
// module id = 945
// module chunks = 0